import React from 'react';
import { useAtom } from 'jotai';

import ToggleSwitch from '~/components/inputs/toggle-switch';
import Tooltip from '~/components/tooltip/tooltip';
import { addProductAtom } from '~/components/lawns/questionnaire/weed-warrior-interstitial';

import styles from '~/components/shipments/shipment.module.scss';

const WeedWarriorCard = () => (
  <div className={styles.shipmentItem}>
    <div className={styles.imageContainer}>
      <img
        src="/images/weed-warrior-thumb.png"
        alt="Weed Warrior"
        width="300"
        height="300"
        className={styles.shipmentItemImage}
      />
      <div className={styles.bestSellerBadge}>BEST SELLER</div>
    </div>
    <div className={styles.shipmentItemTitle}>
      Weed Warrior{' '}
      <span className={styles.shipmentItemTooltip}>
        <Tooltip content="For severe weed issues. Kills ALL vegetation down to root including grass. Ideal for complete lawn resets before seeding or on hardscapes and garden beds. OMRI-listed organic. No staining. Results in 20 minutes." />
      </span>
    </div>
  </div>
);

const WeedWarriorCta = () => {
  const [{ weedWarriorSelected }, setProduct] = useAtom(addProductAtom);

  const handleChange = () => {
    setProduct({ weedWarriorSelected: !weedWarriorSelected });
  };

  return (
    <div className={styles.ctaWrapper}>
      <p className={styles.ctaTagLine}>
        For <strong>extreme weeds,</strong> try Weed Warrior
      </p>
      <div className={styles.toggleWrapper}>
        <ToggleSwitch
          ariaLabel="Add Weed Warrior Herbicide Concentrate to plan"
          checked={weedWarriorSelected}
          handleChange={handleChange}
        />
      </div>
      <div>
        <p className={styles.ctaToggleCopy}>
          {weedWarriorSelected
            ? 'Yes, let’s add to my plan!'
            : 'No, thanks. I’ll skip it.'}
        </p>
        <p className={styles.priceCopy}>Price shown in your cart</p>
      </div>
    </div>
  );
};

export { WeedWarriorCard, WeedWarriorCta };
